module.exports = __webpack_public_path__ + "img/5b06e7f.jpg";